import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { ProgressBarSteps } from '../../types/Cashier';

import styles from './ProgressBar.scss';
import BonusStepActive from './ProgressBars/BonusStepActive/BonusStepActive';
import StepOneActive from './ProgressBars/StepOneActive/StepOneActive';
import StepThreeActive from './ProgressBars/StepThreeActive/StepThreeActive';
import StepTwoActive from './ProgressBars/StepTwoActive/StepTwoActive';
import StepOneCompleted from './ProgressBarsModal/StepOneCompleted/StepOneCompleted';
import StepThreeCompleted from './ProgressBarsModal/StepThreeCompleted/StepThreeCompleted';
import StepTwoCompleted from './ProgressBarsModal/StepTwoCompleted/StepTwoCompleted';

interface Props {
  progressBarCompletedSteps?: boolean;
}

const ProgressBar: React.FC<Props> = ({ progressBarCompletedSteps }) => {
  const {
    data: { signupPassed, rmfPassed, progressBarStep, isContinueWithoutBonusSelected }
  } = useWizardContext();
  const SwcHideBonusIconFromProgressBar = useFeature(FeatureFlag.SwcHideBonusIconFromProgressBar);
  const hideBonusIcon = SwcHideBonusIconFromProgressBar || isContinueWithoutBonusSelected;

  let children: React.ReactNode;
  const isSignup = !signupPassed;
  const isRmf = signupPassed && (!rmfPassed || progressBarStep === ProgressBarSteps.AboutYou);
  const isDeposit = rmfPassed && progressBarStep === ProgressBarSteps.Deposit;
  const isBonus = rmfPassed && progressBarStep === ProgressBarSteps.Bonus;

  if (progressBarCompletedSteps) {
    switch (true) {
      case isRmf:
        children = (
          <StepOneCompleted
            classname={styles.completedStepModal}
            vectorClassname={styles.vector}
            hideBonusIcon={hideBonusIcon}
          />
        );
        break;
      case isDeposit:
        children = (
          <StepTwoCompleted
            classname={styles.completedStepModal}
            vectorClassname={styles.vector}
            hideBonusIcon={hideBonusIcon}
          />
        );
        break;
      case isBonus:
        children = (
          <StepThreeCompleted
            hideBonusIcon={hideBonusIcon}
            classname={styles.completedStepModal}
            vectorClassname={styles.vector}
          />
        );
        break;
    }
    return <div className={styles.progressBarModal}>{children}</div>;
  }

  switch (true) {
    case isSignup:
      children = <StepOneActive classname={styles.active} hideBonusIcon={hideBonusIcon} />;
      break;
    case isRmf:
      children = <StepTwoActive classname={styles.active} hideBonusIcon={hideBonusIcon} />;
      break;
    case isDeposit:
      children = <StepThreeActive classname={styles.active} hideBonusIcon={hideBonusIcon} />;
      break;
    case isBonus:
      children = <BonusStepActive classname={styles.active} />;
      break;
  }
  return <div className={styles.progressBar}>{children}</div>;
};

export default ProgressBar;
